/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_DiningInputs */

const en_val_dining = /** @type {(inputs: Val_DiningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dining`)
};

const es_val_dining = /** @type {(inputs: Val_DiningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comedor`)
};

const fr_val_dining = /** @type {(inputs: Val_DiningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salle à manger`)
};

const de_val_dining = /** @type {(inputs: Val_DiningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esszimmer`)
};

const ja_val_dining = /** @type {(inputs: Val_DiningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダイニング`)
};

const zh_val_dining = /** @type {(inputs: Val_DiningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`餐厅`)
};

const ar_val_dining = /** @type {(inputs: Val_DiningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غرفة الطعام`)
};

const id_val_dining = /** @type {(inputs: Val_DiningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruang Makan`)
};

const it_val_dining = /** @type {(inputs: Val_DiningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sala da Pranzo`)
};

const ru_val_dining = /** @type {(inputs: Val_DiningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Столовая`)
};

const pt_val_dining = /** @type {(inputs: Val_DiningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sala de Jantar`)
};

const ko_val_dining = /** @type {(inputs: Val_DiningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다이닝`)
};

/**
* | output |
* | --- |
* | "Dining" |
*
* @param {Val_DiningInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_dining = /** @type {((inputs?: Val_DiningInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_DiningInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_dining(inputs)
	if (locale === "es") return es_val_dining(inputs)
	if (locale === "fr") return fr_val_dining(inputs)
	if (locale === "de") return de_val_dining(inputs)
	if (locale === "ja") return ja_val_dining(inputs)
	if (locale === "zh") return zh_val_dining(inputs)
	if (locale === "ar") return ar_val_dining(inputs)
	if (locale === "id") return id_val_dining(inputs)
	if (locale === "it") return it_val_dining(inputs)
	if (locale === "ru") return ru_val_dining(inputs)
	if (locale === "pt") return pt_val_dining(inputs)
	return ko_val_dining(inputs)
});